import { EntityId } from '../../entity-id.type';
import { IBaseEntityType } from '../../base';
import { ISite } from '@shared/types';

export interface IEventDays {
  end_date_time: string;
  start_date_time: string;
}

export enum IEventStatus {
  Open = 'open',
  Closed = 'closed',
  Pending = 'pending',
}

/**
 * Defines type for a events
 */
export interface IEvent extends IBaseEntityType {
  id: string;
  name: string;
  status?: IEventStatus;
  description?: string;
  event_type_entity_id?: EntityId;
  is_multi_day?: boolean;
  event_days?: IEventDays[];
  available_sites?: ISite[];
}

export interface IProcessedEvent extends IEvent {
  date: string;
  status_for_sort: number;
  date_for_sort: number;
  event_type_entity_name?: string;
}

export interface IEventType extends IBaseEntityType {
  transaction_id: string;
}
